module.exports = __webpack_public_path__ + "static/img/detail1-3.ed59aa65.png";